export default __webpack_public_path__ + "static/media/bg-conquest.84fad95f.png";